<template>
  <van-tabbar v-model="active" v-if="showTabbar" :placeholder="true">
    <van-tabbar-item v-for="(item, index) in menusList" :key="index" @click="goToRouters(index)">
      <span>{{ item.name }}</span>
      <template #icon="props">
        <img :src="props.active ? item.activeIcons : item.icons" />
      </template>
    </van-tabbar-item>
  </van-tabbar>
</template>

<script lang="ts" setup>
import router from '@/router';
import { ref, watch } from 'vue'
import { useRoute } from 'vue-router';
const menusList = ref([
  {
    name: '首页',
    path: '/',
    icons: require('@/assets/images/shouyeimg.png'),
    activeIcons: require('@/assets/images/shouyeimg_1.png')
  },
  {
    name: '找大厅',
    path: '/findTheLobby',
    icons: require('@/assets/images/zhaodatingimg.png'),
    activeIcons: require('@/assets/images/zhaodatingimg_1.png')
  },
  {
    name: '找服务',
    path: '/findServices',
    icons: require('@/assets/images/zhaofuwuimg.png'),
    activeIcons: require('@/assets/images/zhaofuwuimg_1.png')
  },
  {
    name: '我的',
    path: '/my',
    icons: require('@/assets/images/wodeimg.png'),
    activeIcons: require('@/assets/images/wodeimg_1.png')
  }
])
const showTabbar = ref(false);
const active = ref(0);
const routers = useRoute()
const routerList = ref(['/', '/findTheLobby', '/findServices', '/my'])
watch(() => routers.path, (newValue) => {
  if (routerList.value.includes(newValue)) {
      showTabbar.value = true;
    } else {
      showTabbar.value = false;
    }
    if (newValue === '/') {
      active.value = 0
    } else if (newValue === '/findTheLobby') {
      active.value = 1
    } else if (newValue === '/findServices') {
      active.value = 2
    } else if (newValue === '/my') {
      active.value = 3
    }
}, { immediate: true })

const goToRouters = (index: number) => {
  if (index === 0) {
    router.push({
      path: '/'
    })
  }
  if (index === 1) {
    router.push({
      path: '/findTheLobby'
    })
  }
  if (index === 2) {
    router.push({
      path: '/findServices'
    })
  }
  if (index === 3) {
    router.push({
      path: '/my'
    })
  }
}
</script>
